<template>
    <div>
        <div class="page-top mb-1 mb-3 align-center clearfix">
            <h1 class="float-left"> FAQs Categories </h1>
            <router-link to="/addFaqCategory" class="btn btn-primary float-right active"> Add New Faq Category</router-link>
            <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" name="" />
            </div>
        </div>
        <table id="faqCategoryTable" class="table">
            <thead>
            <tr>
                <th style="display: none;"></th>
                <th>Name</th>
                <th class="text-center">Action</th>
            </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null
            };
        },
        methods: {

            showFaqCategoryData(){
                    this.$Progress.start();
                    var faqCategoryTable = $('#faqCategoryTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listFaqCategoryAPI",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $editUrl = '/editFaqCategory/'+full['id'];
                                return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$editUrl+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>'
                                + '<a href="javascript:void(0);" onclick="VueComponents.faqCategoryComponent.methods.deleteFaqCategory('+full['id']+')"><i class="fas fa-trash"></i></a>';
                            }},
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 1 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    faqCategoryTable.search(this.value).draw();
                });
            },
              deleteFaqCategory(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.post('/api/deleteFaqCategoryAPI', {id})
                            .then(res => {
                                    if(res.data.status == '200'){
                                        $('#faqCategoryTable').DataTable().ajax.reload();
                                        this.showToastBox('success',res.data.msg);
                                    }else{
                                        this.showToastBox('error',res.data.msg);
                                    }
                            })
                            .catch(err => {
                            this.showAlertBox('error','System Not Responding Please Try Again');
                            });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.showAlertBox('error','Cancelled','Your decision has been cancelled');
                    }
                });
            },
        },
        mounted() {
            this.showFaqCategoryData();
        },
        created() {
            //
        }
    }
</script>
